import React from 'react';
import './App.css';

import { BrowserRouter as Router, Routes, Route
 } from 'react-router-dom';
import SbtierHeader from './Components/header/header';
import SbtierHome from './Components/SbtierSemiHome';
import SbtierAbout from './Components/SbtierAboutUs';
import SbtierService from './Components/SbtierServices';
import SbtierCareer from './Components/SbtierCarrer';
import SbtierFooter from './Components/footer/footer';
import SbtierContactUs from './Components/SbtierContactUs';

function App() {
  return (
    <Router>
    <div className="App">
      <header className="App-header">
          <SbtierHeader/>
          <Routes>
            <Route path="/" element={<SbtierHome />} />
            <Route path="/Sbtier-AboutUs" element={<SbtierAbout />} />
            <Route path="/Sbtier-Services" element={<SbtierService />} />
            <Route path="/Sbtier-Career" element={<SbtierCareer />} />
            <Route path="/contact-us" element={<SbtierContactUs />} />
          </Routes>
        <SbtierFooter/>
      </header>
    </div>
    </Router>
  );
}

export default App;
